import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ExamineComponent from './components/Examine';
import Main from './routes/Main';
import MbtiResult from './routes/Result';
import MbtiTest from './routes/Test';


export default class MBTIAPP extends Component {
    render() {
        return (
            <Switch>
                <Route path='/mbti/result/:value' component={MbtiResult} exact />
                <Route path='/mbti/examine' component={ExamineComponent} exact />
                <Route path='/mbti/test' component={MbtiTest} exact />
                <Route path='/mbti' component={Main} exact />
            </Switch>
        );
    }
}

